import React from 'react';
import { Link } from 'src/components/Inputs';
import AvailableLanguageLink from '../AvailableLanguageLink';

const FrPlaidAccountTerms = ({ availableLanguages }) => {
  return (
    <>
      <h4 id='plaid-account-terms-fr'>Conditions du Compte Plaid</h4>
      <p>Langues disponibles:</p>
      <ul>
        {availableLanguages &&
          availableLanguages.map((language, i) => {
            return (
              <AvailableLanguageLink
                key={`language-${i}`}
                href={language.href}
                label={language.label}
              />
            );
          })}
      </ul>
      <br />
      <br />
      <p>Date d’entrée en vigueur : 1er décembre 2023</p>
      <p>
        <strong>Fond</strong> Merci d’utiliser Plaid ! Plaid est un service qui
        aide des consommateurs comme vous à connecter leurs comptes financiers,
        à partager leurs données financières, à vérifier leur identité, à
        effectuer des virements et des paiements, et à utiliser d’autres
        produits et services impliquant leurs données financières et d’identité
        avec les applications de leur choix qui utilisent Plaid (« 
        <strong>Applications</strong> »).
      </p>
      <p>
        <strong>Conditions supplémentaires</strong> Les présentes conditions du
        Compte Plaid (les « <strong>Conditions du Compte Plaid</strong> »)
        complètent et intègrent par référence le{' '}
        <Link href='#end-user-services-agreement-us'>
          <a>Contrat de services de l’utilisateur final (États-Unis)</a>
        </Link>{' '}
        et constituent conjointement un contrat entre vous et Plaid (le « 
        <strong>Contrat</strong> »).{' '}
        <strong>
          Veuillez consulter toutes les conditions du{' '}
          <Link href='#end-user-services-agreement-us'>
            <a>Contrat de services de l’utilisateur final (États-Unis)</a>
          </Link>
          , notamment les Sections intitulées Droits relatifs à la Plateforme,
          Nos clauses de non-responsabilité, Responsabilités liées à notre
          Plateforme, Règlement des litiges et Notifications.
        </strong>
      </p>
      <p>
        <strong>Plaid</strong> se réserve le droit de modifier le contrat
        moyennant une notification,{' '}
        <strong>
          comme indiqué dans le dernier paragraphe du{' '}
          <Link href='#end-user-services-agreement-us'>
            <a>Contrat de services de l’utilisateur final (États-Unis)</a>
          </Link>
          , et l’acceptation de ces modifications sera nécessaire pour continuer
          à utiliser votre compte Plaid
        </strong>
        .
      </p>
      <p>
        <strong>Compte Plaid.</strong> Plaid vous permet d’enregistrer et de
        gérer les connexions de vos comptes financiers et les données de
        vérification d’identité sur un compte Plaid (« 
        <strong>Compte Plaid</strong> »). Cela vous permet de vous connecter
        plus rapidement aux applications qui utilisent Plaid et de les utiliser,
        notamment en accédant plus rapidement à votre compte, en partageant des
        données, en vérifiant votre identité, en effectuant des virements et des
        paiements à l’aide des applications, ainsi qu’en utilisant d’autres
        produits et services impliquant vos données financières et d’identité
        dans ces applications. Il convient de tenir compte du fait qu’un compte
        Plaid n’est pas un compte de transactions ou d’actifs au sens de la Loi
        sur le transfert électronique de fonds, qu’il ne stocke pas de fonds et
        qu’il ne vous permet pas d’initier des transferts électroniques de fonds
        ou d’autres paiements, mais qu’il vous permet d’accéder à des
        applications et de les utiliser plus rapidement et plus facilement.
      </p>
      <p>
        Lorsque vous connectez un ou plusieurs comptes financiers à une
        application à l’aide de Plaid, Plaid peut vous demander de fournir et de
        vérifier votre numéro de téléphone, votre adresse électronique ou
        d’autres coordonnées afin de créer votre compte Plaid et de mémoriser
        chacune de vos connexions au sein dudit compte. Lorsque vous vérifiez
        votre identité avec une application via Plaid, Plaid peut vous demander
        si vous souhaitez enregistrer vos données d’identité dans votre compte
        Plaid. En créant un compte Plaid, vous autorisez Plaid à conserver et
        utiliser les connexions de votre compte financier et les données
        d’identité conformément au Contrat et à la{' '}
        <Link href='#política-de-privacidad-aplicable-al-usuario-final'>
          <a>Politique de confidentialité de l’utilisateur final</a>
        </Link>{' '}
        de Plaid.
      </p>
      <p>
        <strong>Fonctionnement de votre compte.</strong> En enregistrant les
        données d’identité et les connexions aux comptes financiers dans votre
        compte Plaid, vous pouvez accéder plus rapidement aux produits et
        services de vos applications et les utiliser. Lorsque vous utilisez à
        nouveau vos données et vos connexions avec vos Applications, votre
        Compte Plaid nous permet de vous reconnaître avec précision et de
        procéder plus rapidement à la vérification de votre identité et à la
        mise en relation de vos comptes sans que vous ayez à saisir à nouveau
        toutes les informations que vous avez enregistrées pour chaque
        Application.
      </p>
      <p>
        Plaid vous permet, par le biais de l’utilisation de processus plus
        rapides via votre compte Plaid: (a) de partager avec les applications,
        nos filiales et nos prestataires de services des données indiquant la
        détention ou non d’un compte Plaid et, le cas échéant, certaines données
        de votre compte Plaid afin que nous et eux puissions vous fournir des
        services, notamment : (i) le nombre et les types de connexions de
        comptes financiers sur votre compte Plaid, (ii) les types de données et
        de documents d’identité sur votre compte Plaid, et (iii) les services et
        les cas d’utilisation que vous fournissent les applications et qui
        peuvent être pris en charge par les connexions de comptes financiers et
        les données d’identité sur votre compte Plaid ; (b) de vous contacter en
        utilisant les données que vous fournissez ou qui sont disponibles dans
        vos données d’identité sauvegardées ou vos connexions de comptes
        financiers, notamment pour envoyer des notifications de sécurité afin de
        confirmer l’activité sur votre compte Plaid et des messages décrivant
        les étapes à suivre pour compléter ou résoudre des problèmes lors du
        processus d’utilisation de Plaid pour embarquer et utiliser vos
        applications ; et (c) de vérifier vos données en vue de vous protéger
        contre la fraude, les fausses déclarations, les activités non autorisées
        ou suspectes, ou d’autres comportements malveillants - les données que
        nous recevons dans le cadre de ce processus de vérification peuvent être
        stockées dans votre compte Plaid pour être utilisées lorsque vous
        partagez à nouveau des données d’identité avec d’autres applications.
      </p>
      <p>
        Pour plus d’informations sur la collecte, l’utilisation et le partage
        par Plaid des données à caractère personnel vous concernant, y compris
        en lien avec votre compte Plaid, veuillez consulter la{' '}
        <Link href='#política-de-privacidad-aplicable-al-usuario-final'>
          <a>Politique de confidentialité de l’utilisateur final</a>
        </Link>{' '}
        de Plaid. Le Contrat et la{' '}
        <Link href='#política-de-privacidad-aplicable-al-usuario-final'>
          <a>Politique de confidentialité de l’utilisateur final de Plaid</a>
        </Link>{' '}
        ne s’appliquent pas à l’utilisation de vos données par les applications
        utilisées. Si vous souhaitez obtenir de plus amples informations sur ces
        pratiques, veuillez consulter les politiques de confidentialité ou les
        conditions de service de ces applications.
      </p>
      <p>
        <strong>Gestion et suppression de votre compte.</strong> Vous pouvez
        consulter et gérer votre compte Plaid sur{' '}
        <Link href='https://my.plaid.com'>
          <a>my.plaid.com</a>
        </Link>{' '}
        ou en contactant{' '}
        <Link href='mailto:privacy@plaid.com'>
          <a>privacy@plaid.com</a>
        </Link>
        . Si vous souhaitez supprimer votre compte Plaid ou si vous avez des
        questions sur la gestion de votre compte Plaid ou sur vos droits en
        matière de données, veuillez contacter{' '}
        <Link href='mailto:privacy@plaid.com'>
          <a>privacy@plaid.com</a>
        </Link>
        .
      </p>
      <p>
        <strong>Votre utilisation et vos restrictions.</strong> Votre compte
        Plaid peut uniquement être utilisé pour accélérer l’intégration et
        l’utilisation des applications qui utilisent Plaid. En créant ou en
        utilisant un Compte Plaid, vous acceptez expressément le Contrat et
        reconnaissez que : (a) toutes les données que vous fournissez et tous
        les comptes financiers auxquels vous vous connectez sont les vôtres ou
        que vous êtes un utilisateur autorisé de ces comptes ; (b) toutes les
        données que vous fournissez pour vérifier votre identité sont complètes
        et exactes ; et (c) vous (i) n’utiliserez pas ou n’accéderez pas au
        Compte Plaid ou aux données connexes d’une autre personne, (ii)
        n’utiliserez pas un Compte Plaid ou des données connexes à des fins
        frauduleuses, illégales ou trompeuses, (iii) ne modifierez pas, ne ferez
        pas d’ingénierie inverse ou ne chercherez pas à obtenir un accès non
        autorisé à un Compte Plaid ou à des systèmes Plaid connexes, (iv) ne
        contournerez pas les mesures conçues pour empêcher ou limiter l’accès à
        toute partie d’un Compte Plaid ou des systèmes connexes de Plaid, (v) ne
        copierez pas, ne modifierez pas et ne créerez pas d’œuvres dérivées d’un
        Compte Plaid ou des systèmes connexes de Plaid d’une manière non
        autorisée par Plaid, (vi) n’accéderez pas à un Compte Plaid ou aux
        systèmes connexes de Plaid à des fins concurrentielles ou ne publierez
        pas de données de référence ou d’informations sur les performances, ou
        (vii) n’utiliserez pas un Compte Plaid ou des systèmes Plaid connexes
        d’une manière susceptible d’endommager, de désactiver, de surcharger ou
        de compromettre leur fonctionnement ou d’interférer avec d’autres
        utilisateurs, de les perturber ou d’avoir un effet négatif sur eux.
      </p>
      <p>
        Vous reconnaissez et comprenez que vous êtes responsable des données que
        vous enregistrez dans votre Compte Plaid. Vous ne fournirez aucune
        donnée : (i) diffamatoire, abusive, harcelante, menaçante, ou portant
        atteinte à un droit ou à la vie privée d’une autre personne ; (ii)
        sectaire, haineuse ou racialement ou autrement offensante ; (iii)
        violente, vulgaire, obscène, pornographique ou autrement sexuellement
        explicite ; (iv) dont le contenu est protégé par une marque ou un droit
        d’auteur, ou dont le contenu porte atteinte aux droits de propriété
        intellectuelle d’une autre personne ou d’une autre société ; ou (v)
        nuisible ou dont on peut raisonnablement s’attendre à ce qu’elle soit
        nuisible à une personne ou à une entité quelconque. Toute utilisation
        non autorisée d’un Compte Plaid est strictement interdite et peut
        entraîner la suppression de votre Compte Plaid.
      </p>
      <p>
        <strong>Conditions relatives aux appareils sans fil et aux SMS.</strong>{' '}
        Plaid peut vous envoyer des messages SMS (Short Message Service) afin de
        vous fournir un service et/ou de confirmer votre identité au moyen d’une
        authentification à deux facteurs. Vous acceptez de recevoir des messages
        SMS automatisés de Plaid et de l’un de nos fournisseurs de services liés
        aux SMS, y compris par le biais d’un système de composition téléphonique
        automatique, au numéro de téléphone que vous avez fourni. Des tarifs
        pour les messages et les données peuvent s’appliquer. En règle générale,
        vous recevrez un message par demande. Les opérateurs ne sont pas
        responsables des messages reçus en retard ou non délivrés.
      </p>
      <p>
        Vous autorisez votre fournisseur de services sans fil à utiliser ou à
        divulguer des informations sur votre compte et votre appareil sans fil,
        le cas échéant, à Plaid ou à notre fournisseur de services pendant la
        durée de votre relation commerciale, uniquement pour aider Plaid ou
        notre fournisseur de services à vous identifier ou à identifier votre
        appareil sans fil et pour prévenir la fraude. Veuillez consulter{' '}
        <Link href='#política-de-privacidad-aplicable-al-usuario-final'>
          <a>notre Politique de confidentialité de l’utilisateur final</a>
        </Link>{' '}
        pour en savoir plus sur les modalités de traitement de vos données.
      </p>
      <p>
        Les données que votre opérateur sans fil peut divulguer peuvent inclure
        le numéro de téléphone mobile, le nom, l’adresse, l’adresse
        électronique, l’état du réseau, le type de client, le statut du client,
        le type de facturation et les identifiants de l’appareil mobile (IMSI et
        IMEI). Aucune donnée relative aux appareils mobiles ne sera communiquée
        à des tierces parties ou à des sociétés affiliées à des fins de
        marketing ou de promotion. Les données relatives au consentement de la
        personne à l’origine du message texte ne seront pas communiquées à des
        tierces parties.
      </p>
      <p>
        Si vous ne souhaitez pas recevoir de messages SMS de Plaid ou de nos
        fournisseurs de services, ou si vous ne souhaitez plus que votre
        opérateur de téléphonie mobile partage des données vous concernant avec
        Plaid ou nos fournisseurs de services, vous acceptez de répondre STOP à
        tout message SMS de Plaid ou envoyé au nom de Plaid afin de ne plus
        recevoir de notifications par message SMS. Il se peut que vous receviez
        un SMS supplémentaire confirmant votre décision de vous désinscrire. En
        choisissant de vous désinscrire des messages SMS, vous ne recevrez plus
        de messages de Plaid ou de nos fournisseurs de services, à moins que
        vous ne nous demandiez par la suite de vous envoyer des messages SMS ou
        que vous ne vous inscriviez à l’un de nos services, tel qu’un Compte
        Plaid, qui nécessite l’envoi de messages SMS.
      </p>
      <p>
        Si vous rencontrez des problèmes avec les messages SMS de Plaid ou de
        nos fournisseurs de services, vous pouvez répondre avec le mot clé HELP
        pour obtenir de l’aide, ou vous pouvez contacter{' '}
        <Link href='https://my.plaid.com/help'>
          <a>https://my.plaid.com/help</a>
        </Link>
        .
      </p>
      <p>
        <strong>
          Les personnes de moins de 18 ans ne peuvent pas créer de Compte Plaid.
        </strong>{' '}
        En créant et en utilisant votre Compte Plaid, vous déclarez et
        garantissez être âgé de 18 ans ou plus. Si vous avez des raisons de
        croire qu’une personne de moins de 18 ans utilise nos Services, veuillez
        nous contacter à l’adresse{' '}
        <Link href='mailto:privacy@plaid.com'>
          <a>privacy@plaid.com</a>
        </Link>{' '}
        et, après confirmation, nous supprimerons le Compte Plaid concerné, sous
        réserve et conformément à nos exigences en vertu de la loi applicable.
      </p>
      <p>
        <strong>Sécurité.</strong> Plaid met en œuvre des mesures techniques et
        organisationnelles conçues pour protéger votre Compte Plaid contre
        l’accès, l’utilisation, l’altération ou la divulgation non autorisés et
        pour maintenir la sécurité, la confidentialité et l’intégrité de vos
        données. Nous vous invitons toutefois à sécuriser votre compte Plaid et
        vos autres données à caractère personnel, étant entendu que ces données
        sont fournies à vos propres risques. Si vous pensez que votre Compte
        Plaid a été compromis, veuillez nous contacter immédiatement à l’adresse{' '}
        <Link href='mailto:privacy@plaid.com'>
          <a>privacy@plaid.com</a>
        </Link>
        .
      </p>
      <p>
        <strong>Divers.</strong> Tous les termes commençant par une majuscule,
        utilisés mais non définis dans les présentes conditions d’utilisation du
        Compte Plaid, auront la signification qui leur est attribuée dans le{' '}
        <Link href='#end-user-services-agreement-us'>
          <a>Contrat de services de l’utilisateur final (É.-U.)</a>
        </Link>
        . En cas de conflit entre les présentes conditions d’utilisation du
        compte Plaid et le{' '}
        <Link href='#end-user-services-agreement-us'>
          <a>Contrat de services de l’utilisateur final (É.-U.)</a>
        </Link>
        , les présentes conditions d’utilisation du compte Plaid prévaudront et
        s’appliqueront, le cas échéant, à votre utilisation d’un compte Plaid,
        sous réserve que toutes les autres dispositions du{' '}
        <Link href='#end-user-services-agreement-us'>
          <a>Contrat de services de l’utilisateur final (É.-U.)</a>
        </Link>{' '}
        restent pleinement en vigueur. L’acceptation du contrat ou la création,
        l’accès, la gestion ou l’utilisation de votre compte Plaid impliquent
        que vous acceptez le contrat et que vous certifiez disposer de tous les
        droits nécessaires à cet effet. Si vous n’acceptez pas le Contrat,
        veuillez ne pas créer, accéder, gérer ou utiliser un compte Plaid. Si, à
        quelque moment que ce soit, vous n’acceptez plus le Contrat, vous pouvez
        supprimer votre compte Plaid. Plaid, à son entière discrétion, est
        habilitée à désactiver ou supprimer un compte Plaid si (a) elle a des
        motifs de croire qu’une condition du contrat a été violée, (b) votre
        compte Plaid n’est pas utilisé et reste inactif pendant une période
        prolongée, (c) elle a des motifs de croire que votre compte Plaid a été
        utilisé sans autorisation, ou (d) elle est légalement tenue de le faire.
        Plaid se réserve le droit de faire valoir tout autre recours disponible,
        en droit ou en équité, en lien avec cette question.
      </p>

      <hr className='section-divider' />
    </>
  );
};

export default FrPlaidAccountTerms;
